import { AppShell, Button, Text, useTranslation, type NavItem } from "@manapp/ui"
import { Outlet } from "react-router-dom"

import { useAuthController } from "../auth/auth-context"
import { estimatorEnabled } from "../config"
import { LanguageSwitcher } from "./language-switcher"
import { useOrg } from "./org-context"

export function Layout() {
  const { t } = useTranslation()
  const { me, role, capabilities } = useOrg()
  const controller = useAuthController()
  const nav: NavItem[] = [{ to: "/", label: t("nav.overview") }]
  if (estimatorEnabled() && role !== "worker") {
    nav.push(
      { to: "/workbench", label: t("nav.workbench") },
      { to: "/documents", label: t("nav.documents") },
      { to: "/search", label: t("nav.search") },
    )
  }
  if (role === "admin") {
    nav.push({ to: "/members", label: t("nav.members") }, { to: "/audit", label: t("nav.audit") })
    nav.push({ to: "/settings/capabilities", label: t("nav.capabilities") })
  }
  // Display only: the server refuses Business Rules calls without policy.administer.
  if (role !== "worker" && capabilities.includes("policy.administer")) {
    nav.push({ to: "/settings/business-rules", label: t("nav.businessRules") })
  }
  return (
    <AppShell
      productName={t("app.name")}
      nav={nav}
      header={
        <>
          <LanguageSwitcher />
          <Text size="small" className="text-ui-fg-subtle">
            {me.email}
          </Text>
          <Button size="small" variant="secondary" onClick={() => void controller.signOut()}>
            {t("auth.signOut")}
          </Button>
        </>
      }
    >
      <Outlet />
    </AppShell>
  )
}
